import { createSlice } from '@reduxjs/toolkit';

import { BasePropsState } from './base-props-slice.models';
import { setBaseProps, fetchCurrentUser } from './base-props-slice.actions';

export const BASE_PROPS_SLICE_NAME = 'baseProps';

const initialState: BasePropsState = {
  language: 'en',
  currentUser: {
    isLoading: false,
  },
};

const basePropsSlice = createSlice({
  name: BASE_PROPS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // setBaseProps
    builder.addCase(setBaseProps, (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    });

    // fetchCurrentUser
    builder.addCase(fetchCurrentUser.pending, (state) => {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          isLoading: true,
        },
      };
    });
    builder.addCase(fetchCurrentUser.fulfilled, (state, { payload }) => {
      return {
        ...state,
        currentUser: {
          data: payload,
          isLoading: false,
        },
      };
    });
  },
});

export const reducer = basePropsSlice.reducer;
